import * as React from 'react';
const SvgPencil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.858 4.06c-.225.068-.421.261-.795.644l-9.087 9.083a2 2 0 0 0-.487.792l-1.451 4.434c-.19.58.37 1.14.95.95l4.435-1.451a2 2 0 0 0 .793-.487l9.062-9.057c.4-.4.59-.59.67-.82a.94.94 0 0 0 0-.62c-.04-.11-.1-.21-.2-.34a9 9 0 0 0-.47-.49l-1.98-1.978c-.4-.4-.59-.59-.82-.67a1 1 0 0 0-.175-.04 1 1 0 0 0-.135-.01v.01c-.1 0-.21.02-.31.05m.314 2.363 1.412 1.41-1.169 1.168-1.41-1.41zM13.59 9.004l-6.2 6.198-.686 2.095 2.098-.686L15 10.415z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPencil;
